export const iconFontAwesomeMapsShoePrints = (
	<i className="fa-solid fa-shoe-prints"></i>
);
